import { useMemo } from 'react'

import { useAvatarEffectSkins } from '@store'

export const useAvatarsEffects = () => {
  const avatarsEffects = useAvatarEffectSkins()

  const sortedAvatarsEffects = useMemo(() => {
    return avatarsEffects.sort((a) => (a.isAvailable ? -1 : 1))
  }, [avatarsEffects])

  return { avatarsEffects: sortedAvatarsEffects }
}
